import { createSelector } from "reselect";

import { seriesTrendsResourceSelectors } from "..";

/**
 * Create a selector that gets series trends for an array of revisions
 * @param {Object} props
 * @param {array} props.revisions - the revisions to get series for
 * @returns {Function} selector
 */
export function createSeriesTrendsForRevisionsSelector({ revisions }) {
  return createSelector(
    seriesTrendsResourceSelectors.dataSelector,
    seriesTrends => {
      return revisions.reduce((agg, r) => {
        agg[r.id] = seriesTrends[r.attributes.seriesId];
        return agg;
      }, {});
    }
  );
}
